jQuery(function() {

var owl = $("#section-liste-conseils .owl-carousel").owlCarousel({    
    items : 3,
    navContainer : $("#truc-qui-n-existe-pas"), // Bug owl carousel, active l'étape 2 puis la 1 si rien n'est definit ou si navContainer=false
    loop : false,
    nav:false,    
    touchDrag : true,
    autoplay:false,
    dots : false,
    mergeFit: true,
    center: false,
    autowidth : true,
    responsive:{
        0:{
            items:3
        },
        800:{
             items:4
        },
        1000:{
            items:5
        },
        1200:{
            items:6
        },
        1400:{
            items:7
        },
        1600:{
            items:8
        }
    }
});
var owl = $("#section-liste-conseils .owl-carousel").owlCarousel();
$('#section-liste-conseils .liste-categories .chevron.left').on('click',function(){
    owl.trigger('prev.owl.carousel');
});
$('#section-liste-conseils .liste-categories .chevron.right').on('click',function(){
    owl.trigger('next.owl.carousel');
});
});